global.smartorg = {
    r6: {
        lib: {
            ChartExporter: require("./lib/smartorg/chart-exporter.js")
        },
        dragAndDrop: {
            allowDrop: function (ev) {
                ev.preventDefault();
            },
            workbenchDrag: function (ev) {
                ev.dataTransfer.setData("text", ev.target.getAttribute("id"));
            },
            workbenchDrop: function (ev) {
                ev.preventDefault();
                var data = ev.dataTransfer.getData("text");
                var node = document.getElementById(data);
                var c = document.createElement("div");
                c.id = "compare." + node.id;
                c.style.color = "black";
                c.style.fontStyle = "normal";
                if (node.innerText) {
                    c.innerText = node.innerText;
                } else {
                    c.textContent = node.textContent;
                }

                var compareElement = document.getElementById("compareArea");
                compareElement.innerHTML = "";
                compareElement.appendChild(c);
            }
        },
        waitingSpinner: {
            spinners: [],
            show: function () {
                var elem = document.createElement("div");
                elem.style.cssText = "position:absolute; top: 0; " + 
                    "width:100%; height:100vh; z-index:100000000;";
                elem.innerHTML = "<div style='width:100%; height:100%; " + 
                    "background-color: rgba(50, 50, 50, 0.5); " + 
                    "text-align: center; padding: 45vh'>" + 
                    "<i class='fa fa-spinner fa-spin fa-4x'></div>";
                document.body.appendChild(elem);
                smartorg.r6.waitingSpinner.spinners.push(elem);
            },
            hide: function () {
                var list = smartorg.r6.waitingSpinner.spinners;
                while (list.length > 0) {
                    document.body.removeChild(list.pop());
                }
            }
        }
    }
};


// WEBPACK FOOTER //
// ./app/smartorg-global.js